// PhoneMockup — decorative CSS/HTML replica of the Midani mobile home screen
// used on the auth aside (greeting, quick actions, ongoing shift, feed rows).
// Purely presentational (aria-hidden), but copy is still translated so the
// artwork follows the active language.

import { useTranslation } from 'react-i18next';
import Icon from '@/components/common/Icon';

export interface PhoneMockupProps {
  className?: string;
}

const PhoneMockup = ({ className = '' }: PhoneMockupProps) => {
  const { t } = useTranslation();

  return (
    <div className={['phone-mockup', className].filter(Boolean).join(' ')} aria-hidden='true'>
      <div className='phone-mockup__screen'>
        <span className='phone-mockup__avatar'>Z</span>
        <span className='phone-mockup__greeting'>{t('auth_mock_greeting')}</span>

        <div className='phone-mockup__actions'>
          <span className='phone-mockup__action'>
            <span className='phone-mockup__action-tile'>
              <Icon name='clock' size={15} />
            </span>
            {t('auth_mock_time_clock')}
          </span>
          <span className='phone-mockup__action'>
            <span className='phone-mockup__action-tile'>
              <Icon name='calendar-check' size={15} />
            </span>
            {t('auth_mock_schedule')}
          </span>
          <span className='phone-mockup__action phone-mockup__action--active'>
            <span className='phone-mockup__action-tile'>
              <Icon name='square-check-big' size={15} />
            </span>
            {t('auth_mock_tasks')}
          </span>
          <span className='phone-mockup__action'>
            <span className='phone-mockup__action-tile'>
              <Icon name='users' size={15} />
            </span>
            {t('auth_mock_directory')}
          </span>
        </div>

        <div className='phone-mockup__shift'>
          <span className='phone-mockup__shift-col'>
            <span className='phone-mockup__muted'>{t('auth_mock_ongoing_shift')}</span>
            <span className='phone-mockup__working'>{t('auth_mock_working')}</span>
          </span>
          <span className='phone-mockup__shift-col phone-mockup__shift-col--end'>
            <span className='phone-mockup__muted'>{t('auth_mock_started')}</span>
            <span className='phone-mockup__timer'>00:08:35</span>
          </span>
        </div>

        <div className='phone-mockup__row'>
          <Icon
            name='clipboard-list'
            size={14}
            className='phone-mockup__row-icon phone-mockup__row-icon--task'
          />
          <span className='phone-mockup__row-text'>{t('auth_mock_task_due')}</span>
          <span className='phone-mockup__open'>{t('auth_mock_open')}</span>
        </div>
        <div className='phone-mockup__row'>
          <Icon name='repeat-2' size={14} className='phone-mockup__row-icon' />
          <span className='phone-mockup__row-text'>{t('auth_mock_replacements')}</span>
          <span className='phone-mockup__open'>{t('auth_mock_open')}</span>
        </div>
        <div className='phone-mockup__row phone-mockup__row--plain'>
          <span className='phone-mockup__row-avatar'>L</span>
          <span className='phone-mockup__row-text'>{t('auth_mock_welcome')}</span>
        </div>
      </div>
    </div>
  );
};

export default PhoneMockup;
